module.exports = __webpack_public_path__ + "static/media/mdsg__.d12482cc.svg";